const store = 'user';

export const isLoggedIn = [store, 'isLoggedIn'];
export const links = [store, 'links'];
export const reportsHomeLink = [store, 'reportsHomeLink'];
export const reportsQueueLink = [store, 'reportsQueueLink'];
export const educatorBid = [store, 'userBid'];
export const userInfo = [store];
export const userDataLoaded = [educatorBid, (e) => !!e];
export const chartPreferences = [store, 'chartPreferences'];
export const profileCheckCompleted = [store, 'profileCheckCompleted'];

export default {
    fullStore: [store],
    isLoggedIn,
    links,
    reportsHomeLink,
    reportsQueueLink,
    educatorBid,
    userInfo,
    userDataLoaded,
    chartPreferences,
    profileCheckCompleted,
};
